/**
 * @module RecommendationCard
 */

import Component from '../base/Component';
import './styles.css';

/**
 * Рекомендуемый товар.
 */
export default class RecommendationCard extends Component {
    static className = 'recommendation-card';

    initElements() {
        this.elements = {};
    }

    init(options) {
        super.init(options);
    }
}
